var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"resizer",class:{ sm: _vm.small },on:{"mousedown":_vm.startResize}},[_c('e-svg-icon',{attrs:{"size":_vm.small ? 'xs' : 'md'}},[_vm._v("resizer")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }